import React from "react";
import logoIcon1 from "../../Assets/About/wwp_img1.svg";
import logoIcon2 from "../../Assets/About/wwp_img2.svg";
import logoIcon3 from "../../Assets/About/wwp_img3.svg";
import logoIcon4 from "../../Assets/About/wwp_img4.svg";
import logoIcon5 from "../../Assets/About/wwp_img5.svg";
import logoIcon6 from "../../Assets/About/wwp_img6.svg";

import cardImg1 from "../../Assets/About/cardImg1.svg";
import cardImg2 from "../../Assets/About/img4.jpg";
import cardImg3 from "../../Assets/About/cardImg3.svg";
import cardImg4 from "../../Assets/About/img1.jpg";
import cardImg5 from "../../Assets/About/img2.jpg";
import cardImg6 from "../../Assets/About/img3.jpg";

const data = [
  {
    id: 1,
    logoIcon: logoIcon1,
    title: "Body Massages",
    content:
      "Relaxes muscles, improves circulation, and reduces stress using tailored massage techniques.",
    cardImage: cardImg1,
  },
  {
    id: 2,
    logoIcon: logoIcon2,
    title: "Oil Therapy",
    content:
      "Warm oils nourish skin, relieve tension, enhance blood flow, and provide deep relaxation.",
    cardImage: cardImg2,
  },
  {
    id: 3,
    logoIcon: logoIcon3,
    title: "Aroma Therapy",
    content:
      "Essential oils boost mood, reduce anxiety, and promote relaxation through therapeutiss",
    cardImage: cardImg3,
  },
  {
    id: 4,
    logoIcon: logoIcon4,
    title: "Waxing",
    content:
      "Removes hair from the root, leaving skin smooth, soft, and hair-free for weeks.",
    cardImage: cardImg4,
  },
  {
    id: 5,
    logoIcon: logoIcon5,
    title: "Facials",
    content:
      "Oil therapy applies natural oils to the body, promoting muscle relaxation and skin nourishment.",
    cardImage: cardImg5,
  },
  {
    id: 6,
    logoIcon: logoIcon6,
    title: "Manicure & Pedicure",
    content:
      "Manicures and pedicures groom and beautify hands and feet, including nail trimming, shaping, ",
    cardImage: cardImg6,
  },
];

const WhatWeProvide = () => {
  return (
    <div className=" bg-[#FFEFEA] p-8 md:p-16 flex gap-8 flex-col items-center  ">
      <h2
        className="text-[#202020] font-serif text-center font-extrabold text-3xl md:text-5xl"
        data-aos="fade-right"
      >
        What We Provide
      </h2>
      <p
        className="px-2 poppins-thin  tracking-wide leading-6  lg:w-[80%] font-[500] text-[#5F5F5F] text-base md:text-lg capitalize text-center"
        data-aos="fade-left"
      >
        Discover a world of tranquility, luxury, and personalized care as you
        embark on a journey of self-care and renewal. Visit us today and let us
        transport you to a realm of beauty and serenity.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
        {data &&
          data.length > 0 &&
          data?.map((item) => {
            return <Card item={item} key={item.id} />;
          })}
      </div>
    </div>
  );
};

export default WhatWeProvide;

function Card({ item }) {
  return (
    <div
      className="flex flex-col items-center justify-center bg-white rounded-md space-y-4 py-4 md:py-8 md:gap-4 px-2"
      data-aos={item.animation}
    >
      <img
        className=" object-cover mx-auto"
        src={item.logoIcon}
        alt={item.title + "logo"}
      />
      <div className="md:px-4">
        <h2 className="text-2xl font-bold tracking-wide font-serif text-center mb-2">
          {item.title}
        </h2>
        <p className="text-[#8A8A8A] mx-2 poppins-thin leading-6  tracking-wide md:text-lg  text-base text-center capitalize">
          {item.content}
        </p>
      </div>

      <img
        className="object-cover mx-auto h-[15rem]"
        src={item.cardImage}
        alt={item.title}
      />
    </div>
  );
}
